'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _contextTypes;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = require('@helpscout/react-utils/dist/hoistNonReactStatics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _utils = require('./utils');

var _FrameManager = require('./FrameManager');

var _FrameManager2 = _interopRequireDefault(_FrameManager);

var _utils2 = require('../utils');

var _FrameProvider = require('../FrameProvider');

var _ScopeProvider = require('../ScopeProvider');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var contextTypes = (_contextTypes = {}, _defineProperty(_contextTypes, _utils.themeChannel, _propTypes2.default.object), _defineProperty(_contextTypes, _FrameProvider.channel, _propTypes2.default.object), _defineProperty(_contextTypes, _ScopeProvider.channel, _propTypes2.default.object), _contextTypes);
var defaultProps = {
  pure: true
};

function createEmotionStyled(emotion, view, options) {
  // Custom Fancy, non-Emotion default options
  var _defaultProps$options = _extends({}, defaultProps, options),
      pure = _defaultProps$options.pure;

  var _createStyled = function createStyled(tag, options) {
    if (process.env.NODE_ENV !== 'production') {
      if (tag === undefined) {
        throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
      }
    }

    var staticClassName = void 0;
    var identifierName = void 0;
    var stableClassName = void 0;
    var shouldForwardProp = void 0;

    if (options !== undefined) {
      staticClassName = options.e;
      identifierName = options.label;
      stableClassName = options.target;
      shouldForwardProp = tag.__emotion_forwardProp && options.shouldForwardProp ? function (propName) {
        return tag.__emotion_forwardProp(propName) && // $FlowFixMe
        options.shouldForwardProp(propName);
      } : options.shouldForwardProp;
    }

    var isReal = tag.__emotion_real === tag;
    var baseTag = staticClassName === undefined ? isReal && tag.__emotion_base || tag : tag;

    if (typeof shouldForwardProp !== 'function') {
      shouldForwardProp = typeof baseTag === 'string' && baseTag.charAt(0) === baseTag.charAt(0).toLowerCase() ? _utils.testPickPropsOnStringTag : _utils.testPickPropsOnComponent;
    }

    return function () {
      var args = arguments;
      var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

      if (identifierName !== undefined) {
        styles.push('label:' + identifierName + ';');
      }

      if (staticClassName === undefined) {
        if (args[0] == null || args[0].raw === undefined) {
          styles.push.apply(styles, args);
        } else {
          styles.push(args[0][0]);
          var len = args.length;
          var i = 1;

          for (; i < len; i++) {
            styles.push(args[i], args[0][i]);
          }
        }
      }

      var OuterBaseComponent = pure ? view.PureComponent : view.Component;

      var Styled = function (_OuterBaseComponent) {
        _inherits(Styled, _OuterBaseComponent);

        function Styled() {
          var _ref;

          var _temp, _this, _ret;

          _classCallCheck(this, Styled);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Styled.__proto__ || Object.getPrototypeOf(Styled)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.emotion = emotion, _this.__hasSetEmotion = false, _temp), _possibleConstructorReturn(_this, _ret);
        } // $FlowFixMe
        // Custom instance properties


        _createClass(Styled, [{
          key: 'componentWillMount',
          value: function componentWillMount() {
            if (this.context[_utils.themeChannel] !== undefined) {
              this.unsubscribe = this.context[_utils.themeChannel].subscribe(_utils.setTheme.bind(this));
            }
            /**
             * Extra channel for the Frame
             */


            if (this.context[_FrameProvider.channel] !== undefined) {
              this.unsubscribeFrame = this.context[_FrameProvider.channel].subscribe(_utils.setFrame.bind(this));
            }
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            if (this.unsubscribe !== undefined) {
              this.context[_utils.themeChannel].unsubscribe(this.unsubscribe);
            }
            /**
             * Extra channel for the Frame
             */


            if (this.unsubscribeFrame !== undefined) {
              this.context[_FrameProvider.channel].unsubscribe(this.unsubscribe);
            }
          }
          /**
           * Ensures that styled components that appear in iFrames,
           * determined by the FrameProvider, have their styles injected
           * into the iFrame.
           *
           * This is done by instantiating a new Emotion instance, with a
           * custom container.
           */

        }, {
          key: 'setEmotion',
          value: function setEmotion() {
            // $FlowFixMe
            var frame = this.state.frame;
            if (!frame) return;
            if (this.__hasSetEmotion) return;
            this.emotion = _FrameManager2.default.getEmotion(frame);
            this.__hasSetEmotion = true;
          }
          /**
           * Retrieves the appropriate document, with an attempt to retrieve
           * it from emotion (potentially set by the FrameProvider), falling
           * back to window.document.
           *
           * @return {document}
           */

        }, {
          key: 'getDocument',
          value: function getDocument() {
            return this.state.frame || (0, _utils2.getDocumentFromReactComponent)(this);
          }
          /**
           * Retrieves the scope selector, either from a ScopeProvider, or
           * from props.
           */

        }, {
          key: 'getScope',
          value: function getScope() {
            if (this.props.scope) return this.props.scope;

            if (this.context[_ScopeProvider.channel]) {
              return this.context[_ScopeProvider.channel].scope;
            } else {
              return '';
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var props = this.props,
                state = this.state;
            this.mergedProps = (0, _utils.pickAssign)(_utils.testAlwaysTrue, {}, props, {
              theme: props.theme || state !== null && state.theme || {}
            });
            var className = '';
            var classInterpolations = [];
            this.setEmotion();

            if (props.className) {
              if (staticClassName === undefined) {
                className += this.emotion.getRegisteredStyles(classInterpolations, props.className);
              } else {
                className += props.className + ' ';
              }
            }

            if (staticClassName === undefined) {
              /* Replaces emotion.css, with enhanced emotion.cssWithScope */
              if (this.emotion.hasOwnProperty('cssWithScope') && typeof this.emotion.cssWithScope === 'function') {
                className += this.emotion.cssWithScope(this.getScope()).apply(this, styles.concat(classInterpolations));
              } else {
                className += this.emotion.css.apply(this, styles.concat(classInterpolations));
              }
            } else {
              className += staticClassName;
            }

            if (stableClassName !== undefined) {
              className += ' ' + stableClassName;
            }

            return view.createElement(baseTag, // $FlowFixMe
            (0, _utils.pickAssign)(shouldForwardProp, {}, props, {
              className: className,
              ref: props.innerRef
            }));
          }
        }]);

        return Styled;
      }(OuterBaseComponent);

      Styled.displayName = identifierName !== undefined ? identifierName : 'Styled(' + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ')';

      if (tag.defaultProps !== undefined) {
        // $FlowFixMe
        Styled.defaultProps = tag.defaultProps;
      }

      Styled.contextTypes = contextTypes;
      Styled.__emotion_styles = styles;
      Styled.__emotion_base = baseTag;
      Styled.__emotion_real = Styled;
      Styled.__emotion_forwardProp = shouldForwardProp;
      Object.defineProperty(Styled, 'toString', {
        enumerable: false,
        value: function value() {
          if (process.env.NODE_ENV !== 'production' && stableClassName === undefined) {
            return 'NO_COMPONENT_SELECTOR';
          } // $FlowFixMe


          return '.' + stableClassName;
        }
      });

      Styled.withComponent = function (nextTag, nextOptions) {
        return _createStyled(nextTag, nextOptions !== undefined ? // $FlowFixMe
        (0, _utils.pickAssign)(_utils.testAlwaysTrue, {}, options, nextOptions) : options).apply(undefined, _toConsumableArray(styles));
      };

      return (0, _hoistNonReactStatics2.default)(Styled, baseTag);
    };
  };

  if (process.env.NODE_ENV !== 'production' && typeof Proxy !== 'undefined') {
    _createStyled = new Proxy(_createStyled, {
      get: function get(target, property) {
        switch (property) {
          // react-hot-loader tries to access this stuff
          case '__proto__':
          case 'name':
          case 'prototype':
          case 'displayName':
            {
              return target[property];
            }

          default:
            {
              throw new Error('You\'re trying to use the styled shorthand without babel-plugin-this.' + ('\nPlease install and setup babel-plugin-emotion or use the function call syntax(`styled(\'' + property + '\')` instead of `styled.' + property + '`)'));
            }
        }
      }
    });
  }

  return _createStyled;
}

exports.default = createEmotionStyled;